import { api } from '@/boot/axios'

export async function fetchStoreOrderQueue (locationId, options = {}) {
  const params = { location_id: locationId }
  if (options.fulfillmentStatus) {
    params.fulfillment_status = options.fulfillmentStatus
  }
  if (options.activeOnly === false) {
    params.active_only = '0'
  }
  if (options.page != null) {
    params.page = options.page
  }
  if (options.perPage != null) {
    params.per_page = options.perPage
  }
  if (options.q) {
    params.q = options.q
  }
  const { data } = await api.get('/store-orders/queue', { params })
  return data
}

export async function updateStoreOrderFulfillment (saleId, fulfillmentStatus, extras = {}) {
  const body = {
    fulfillment_status: fulfillmentStatus
  }
  if (extras.carrier) {
    body.carrier = extras.carrier
  }
  if (extras.tracking_number) {
    body.tracking_number = extras.tracking_number
  }
  const { data } = await api.patch(`/store-orders/sales/${saleId}/fulfillment`, body)
  return data
}

export async function markStoreOrderReturned (saleId, note) {
  const body = {}
  if (note) {
    body.note = note
  }
  const { data } = await api.post(`/store-orders/sales/${saleId}/mark-returned`, body)
  return data
}
